import React, { useState, useEffect } from "react";
import { Rept, sto } from "../../../Context/InshData";
import Grid from "@material-ui/core/Grid";
import tafqeet from "../../../utils/tafqeet";
import { Divider } from "@material-ui/core";

function BodyAdvances({ found }) {

    const styf = { fontWeight: "1200" };
    const styR = { fontWeight: "1200", textAlign: "right", direction: "rtl", paddingBottom: "0.5rem" };
    const styRD = {
        fontWeight: "1200", textAlign: "right", direction: "rtl", paddingBottom: "0.5rem",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    };

    const styLD = {
        fontWeight: "1200", textAlign: "left", direction: "ltr", paddingBottom: "0.5rem",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    };

    const styRBi = {
        fontWeight: "bold", textAlign: "right", direction: "rtl",
        fontSize: "1.1rem", paddingBottom: "0.5rem"
    };

    const styleLargeR={ fontWeight: "bold", textAlign: "center", direction: "rtl", textAlign: "Right",fontSize:"1.2rem" };

    const styTable = { fontWeight: "1200", textAlign: "center", border: "solid 2px", padding:"0.5rem",backgroundColor:"#f1f1fa"};
    const styTable2 = { fontWeight: "1200", textAlign: "center", border: "solid 2px", padding:"0.5rem"};



    return (
        <Grid item container
            justifyContent="center"
            style={{
                paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
            }}>

            <Grid item container xs={12} style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
                <Grid item container xs={12} style={{
                    fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem",
                    paddingBottom: "0.5rem", borderRadius: "px", textAlign: "center"
                }}
                >

                    <Grid item container xs={12} style={{ padding: "0.5rem" }}>
                        <Grid item xs={12} style={styRBi} >
                            {"تم صرف سلفة للموظف          /"}{"          "}{Rept.emp}
                        </Grid>
                        <Grid item xs={12} style={styRBi} >
                            {"مبلغ وقدرة            /"} {"       "}{Rept.amount}
                        </Grid>
                        <Grid item xs={12} style={styleLargeR}>
                            {tafqeet(Rept?.amount, "SAR")}
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12} style={{ paddingTop: "1rem" }}>
                            <Divider style={{ background: '#4a82b9', height: 1.5 }} />
                            <Divider
                                style={{ background: '#4a82b9', marginTop: 3, height: 1.5 }}
                            />
                        </Grid>
                        <br />
                        <br />

                        <Grid item container style={{direction: "rtl"}} lg={12} md={12} sm={12} xs={12} >
                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable}>
                                <div>
                                    {"المبلغ"}
                                </div>
                            </Grid>

                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable}>
                                <div>
                                    {"التاريخ"}
                                </div>
                            </Grid>
                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable}>
                                <div>
                                    {"نوع الدفع"}
                                </div>
                            </Grid>
                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable}>
                                <div>
                                    {"البيان"}
                                </div>
                            </Grid>

                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable2}>
                                <div>
                                    {Rept.amount}
                                </div>
                            </Grid>

                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable2}>
                                <div>
                                    {Rept.date}
                                </div>
                            </Grid>
                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable2}>
                                <div>
                                    {Rept.kind}
                                </div>
                            </Grid>
                            <Grid item lg={3} md={3} sm={3} xs={3} style={styTable2}>
                                <div>
                                    {Rept.notes}
                                </div>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}></Grid>
                        <Grid item xs={12}></Grid>
                        <br />
                        <br />
                        <Grid item xs={12} >
                            <div  style={styleLargeR}>{"وذالك مقابل سلفة في شهر  "}{Rept.month} {"  "}{"سنة  "}{Rept.year}</div>
                        </Grid>

                        

                       

                        <Grid item xs={12} style={styRD}>
                            {" الاسم :............................."}
                        </Grid>
                        <br />

                        <Grid item xs={12} style={styRD}>
                            {"الـتوقــيع :......................."}
                        </Grid>
                        <br />

                        <Grid item xs={12} style={styR}>
                        {"تاريخ الاستلام :......................."}
                        </Grid>
                        <br />
                        </Grid>

                </Grid>

            </Grid>

        </Grid>
    );
}
export default BodyAdvances;